import { c as _c } from "react/compiler-runtime";
function SedanSVG() {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path fillRule="evenodd" clipRule="evenodd" d="M62 30.5C64.2091 30.5 66 28.7091 66 26.5C66 24.2909 64.2091 22.5 62 22.5C59.7909 22.5 58 24.2909 58 26.5C58 28.7091 59.7909 30.5 62 30.5ZM62 32.5C65.3137 32.5 68 29.8137 68 26.5C68 23.1863 65.3137 20.5 62 20.5C58.6863 20.5 56 23.1863 56 26.5C56 29.8137 58.6863 32.5 62 32.5Z" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path fillRule="evenodd" clipRule="evenodd" d="M20 30.5C22.2091 30.5 24 28.7091 24 26.5C24 24.2909 22.2091 22.5 20 22.5C17.7909 22.5 16 24.2909 16 26.5C16 28.7091 17.7909 30.5 20 30.5ZM20 32.5C23.3137 32.5 26 29.8137 26 26.5C26 23.1863 23.3137 20.5 20 20.5C16.6863 20.5 14 23.1863 14 26.5C14 29.8137 16.6863 32.5 20 32.5Z" />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M25.4856 8.32837C26.668 7.78263 27.9548 7.5 29.2571 7.5H41.4831C42.9725 7.5 44.4386 7.86963 45.75 8.57576L56.8234 14.5384L71.2904 16.7989C72.5219 16.9913 73.5062 17.9252 73.7629 19.1449L74.7169 23.676C75.2403 26.1621 73.3434 28.5 70.8027 28.5H67.5V26.5H70.8027C72.073 26.5 73.0215 25.3311 72.7598 24.088L71.8058 19.5569C71.7203 19.1503 71.3922 18.839 70.9817 18.7749L56.1766 16.4616L44.8018 10.3367C43.7818 9.78749 42.6415 9.5 41.4831 9.5H29.2571C28.2442 9.5 27.2434 9.71982 26.3237 10.1443L14.7781 15.473L8.37597 16.2733C7.87554 16.3358 7.5 16.7612 7.5 17.2656V23H6V24.7654C6 25.2631 6.36593 25.685 6.85858 25.7554L15.6414 27.01L15.3586 28.99L6.57574 27.7353C5.09779 27.5241 4 26.2584 4 24.7654V23C4 22.0681 4.63739 21.285 5.5 21.063V17.2656C5.5 15.7526 6.62661 14.4764 8.1279 14.2887L14.2219 13.527L25.4856 8.32837ZM29.1803 12.5C28.5594 12.5 27.9469 12.6446 27.3915 12.9223L22 15.618V17H51.2639L43.1085 12.9223C42.5531 12.6446 41.9406 12.5 41.3197 12.5H29.1803ZM26.4971 11.1334C27.3302 10.7169 28.2489 10.5 29.1803 10.5H41.3197C42.2511 10.5 43.1698 10.7169 44.0029 11.1334L52.4347 15.3493C53.0876 15.6758 53.5 16.343 53.5 17.0729C53.5 18.1372 52.6372 19 51.5729 19H22C20.8954 19 20 18.1046 20 17V15.618C20 14.8605 20.428 14.168 21.1056 13.8292L26.4971 11.1334ZM57 28.5H25.5V26.5H57V28.5Z" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fillRule="evenodd" clipRule="evenodd" d="M35 18.5V11.5H37V18.5H35Z" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <path fillRule="evenodd" clipRule="evenodd" d="M38 21.5C38 20.9477 38.4477 20.5 39 20.5H41C41.5523 20.5 42 20.9477 42 21.5C42 22.0523 41.5523 22.5 41 22.5H39C38.4477 22.5 38 22.0523 38 21.5Z" />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span><svg className="pt-1 selected-color mx-auto" width="80" height="41" viewBox="0 0 80 41" fill="black" xmlns="http://www.w3.org/2000/svg" data-v-c08e9c5a="" data-v-721a5644="">{t0}{" "}{t1}{" "}{t2}{" "}{t3}{" "}{t4}{" "}<path fillRule="evenodd" clipRule="evenodd" d="M26 21.5C26 20.9477 26.4477 20.5 27 20.5H29C29.5523 20.5 30 20.9477 30 21.5C30 22.0523 29.5523 22.5 29 22.5H27C26.4477 22.5 26 22.0523 26 21.5Z" /></svg></span>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
}
function TruckSVG() {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path fillRule="evenodd" clipRule="evenodd" d="M62.5 33C64.9853 33 67 30.9853 67 28.5C67 26.0147 64.9853 24 62.5 24C60.0147 24 58 26.0147 58 28.5C58 30.9853 60.0147 33 62.5 33ZM62.5 35C66.0899 35 69 32.0899 69 28.5C69 24.9101 66.0899 22 62.5 22C58.9101 22 56 24.9101 56 28.5C56 32.0899 58.9101 35 62.5 35Z" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path fillRule="evenodd" clipRule="evenodd" d="M20.5 33C22.9853 33 25 30.9853 25 28.5C25 26.0147 22.9853 24 20.5 24C18.0147 24 16 26.0147 16 28.5C16 30.9853 18.0147 33 20.5 33ZM20.5 35C24.0899 35 27 32.0899 27 28.5C27 24.9101 24.0899 22 20.5 22C16.9101 22 14 24.9101 14 28.5C14 32.0899 16.9101 35 20.5 35Z" />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M26.4062 7.85019C26.4861 6.25356 27.8039 5 29.4025 5H43.779C45.7639 5 47.6931 5.65617 49.2664 6.86638L59.8558 15.0121L71.7555 15.4371C73.2776 15.4914 74.5174 16.6777 74.6389 18.1959L75.2377 25.681C75.4239 28.0085 73.5853 30 71.2504 30H68.5V28H71.2504C72.4179 28 73.3371 27.0042 73.244 25.8405L72.6452 18.3554C72.6048 17.8493 72.1915 17.4539 71.6841 17.4358L59.1442 16.9879L48.047 8.45163C46.8233 7.51036 45.3228 7 43.779 7H29.4025C28.8696 7 28.4304 7.41785 28.4037 7.95006L27.9513 17H8.5V24.5H7V26.291C7 26.7831 7.35799 27.202 7.84404 27.2788L15.656 28.5122L15.344 30.4878L7.53211 29.2543C6.07396 29.0241 5 27.7672 5 26.291V24.5C5 23.5681 5.63739 22.785 6.5 22.563V17C6.5 15.8954 7.39543 15 8.5 15H26.0487L26.4062 7.85019ZM30 10C30 8.89543 30.8954 8 32 8H43.7707C45.1151 8 46.4205 8.4515 47.4776 9.28209L52.8275 13.4856C53.2022 13.78 53.4595 14.1986 53.553 14.666L53.7414 15.6078C53.9889 16.8454 53.0423 18 51.7802 18H32C30.8954 18 30 17.1046 30 16V10ZM43.7707 10H32V16H51.7802L51.5918 15.0582L46.242 10.8547C45.5372 10.301 44.6669 10 43.7707 10ZM57 30H26.5V28H57V30Z" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fillRule="evenodd" clipRule="evenodd" d="M39 16V9H41V16H39Z" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <path fillRule="evenodd" clipRule="evenodd" d="M42 21C42 20.4477 42.4477 20 43 20H45C45.5523 20 46 20.4477 46 21C46 21.5523 45.5523 22 45 22H43C42.4477 22 42 21.5523 42 21Z" />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <svg className="pt-1 selected-color mx-auto" width="80" height="40" viewBox="0 0 80 40" fill="black" xmlns="http://www.w3.org/2000/svg" data-v-c08e9c5a="" data-v-721a5644="">{t0}{" "}{t1}{" "}{t2}{" "}{t3}{" "}{t4}{" "}<path fillRule="evenodd" clipRule="evenodd" d="M31 21C31 20.4477 31.4477 20 32 20H34C34.5523 20 35 20.4477 35 21C35 21.5523 34.5523 22 34 22H32C31.4477 22 31 21.5523 31 21Z" /></svg>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
}
function SUVSVG() {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path fillRule="evenodd" clipRule="evenodd" d="M62.5 33C64.9853 33 67 30.9853 67 28.5C67 26.0147 64.9853 24 62.5 24C60.0147 24 58 26.0147 58 28.5C58 30.9853 60.0147 33 62.5 33ZM62.5 35C66.0899 35 69 32.0899 69 28.5C69 24.9101 66.0899 22 62.5 22C58.9101 22 56 24.9101 56 28.5C56 32.0899 58.9101 35 62.5 35Z" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path fillRule="evenodd" clipRule="evenodd" d="M19.5 33C21.9853 33 24 30.9853 24 28.5C24 26.0147 21.9853 24 19.5 24C17.0147 24 15 26.0147 15 28.5C15 30.9853 17.0147 33 19.5 33ZM19.5 35C23.0899 35 26 32.0899 26 28.5C26 24.9101 23.0899 22 19.5 22C15.9101 22 13 24.9101 13 28.5C13 32.0899 15.9101 35 19.5 35Z" />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M14.6873 7C14.3213 7 13.9846 7.19989 13.8094 7.52115L9.35473 15.688C8.79388 16.7162 8.5 17.8687 8.5 19.04V24.5H7V26.322C7 26.8073 7.34836 27.2225 7.82621 27.3068L14.6738 28.5152L14.3262 30.4848L7.47864 29.2764C6.04507 29.0234 5 27.7778 5 26.322V24.5C5 23.5681 5.63739 22.785 6.5 22.563V19.04C6.5 17.5341 6.87785 16.0523 7.59894 14.7303L12.0536 6.56344C12.5793 5.59966 13.5894 5 14.6873 5H42.0778C43.8546 5 45.5917 5.52594 47.0701 6.51155L59.8201 15.0116L71.0242 15.4425C72.3674 15.4942 73.5123 16.433 73.826 17.7402L75.5844 25.0665C76.188 27.5818 74.2815 30 71.6948 30H68.5V28H71.6948C72.9882 28 73.9414 26.7909 73.6396 25.5333L71.8813 18.2069C71.7767 17.7712 71.3951 17.4582 70.9473 17.441L59.1799 16.9884L45.9607 8.17565C44.8108 7.40907 43.4598 7 42.0778 7H14.6873ZM21.8405 9.51493C22.0631 8.62459 22.863 8 23.7808 8H41.9471C43.1608 8 44.346 8.36812 45.3462 9.05575L51.7321 13.446C52.161 13.7409 52.4581 14.1914 52.5602 14.7019L52.7414 15.6078C52.9889 16.8454 52.0423 18 50.7802 18H22.2808C20.9796 18 20.0249 16.7772 20.3405 15.5149L21.8405 9.51493ZM41.9471 10L23.7808 10L22.2808 16H50.7802L50.599 15.0941L44.2132 10.7038C43.5464 10.2454 42.7562 10 41.9471 10ZM58 30H25.5V28H58V30Z" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fillRule="evenodd" clipRule="evenodd" d="M35 16V9H37V16H35Z" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <path fillRule="evenodd" clipRule="evenodd" d="M38 21C38 20.4477 38.4477 20 39 20H41C41.5523 20 42 20.4477 42 21C42 21.5523 41.5523 22 41 22H39C38.4477 22 38 21.5523 38 21Z" />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <svg className="pt-1 selected-color mx-auto" width="80" height="40" viewBox="0 0 80 40" fill="black" xmlns="http://www.w3.org/2000/svg" data-v-c08e9c5a="" data-v-721a5644="">{t0}{" "}{t1}{" "}{t2}{" "}{t3}{" "}{t4}{" "}<path fillRule="evenodd" clipRule="evenodd" d="M24 21C24 20.4477 24.4477 20 25 20H27C27.5523 20 28 20.4477 28 21C28 21.5523 27.5523 22 27 22H25C24.4477 22 24 21.5523 24 21Z" /></svg>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
}
function VanSVG() {
  const $ = _c(7);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path fillRule="evenodd" clipRule="evenodd" d="M61 32C63.2091 32 65 30.2091 65 28C65 25.7909 63.2091 24 61 24C58.7909 24 57 25.7909 57 28C57 30.2091 58.7909 32 61 32ZM61 34C64.3137 34 67 31.3137 67 28C67 24.6863 64.3137 22 61 22C57.6863 22 55 24.6863 55 28C55 31.3137 57.6863 34 61 34Z" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path fillRule="evenodd" clipRule="evenodd" d="M19 32C21.2091 32 23 30.2091 23 28C23 25.7909 21.2091 24 19 24C16.7909 24 15 25.7909 15 28C15 30.2091 16.7909 32 19 32ZM19 34C22.3137 34 25 31.3137 25 28C25 24.6863 22.3137 22 19 22C15.6863 22 13 24.6863 13 28C13 31.3137 15.6863 34 19 34Z" />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M14.3541 9C13.5966 9 12.904 9.428 12.5652 10.1056L11.0836 13.0689C10.0422 15.1517 9.5 17.4484 9.5 19.7771V24.5H8V26.3604C8 26.8371 8.33646 27.2475 8.80388 27.341L14.6961 28.5194L14.3039 30.4806L8.41165 29.3021C7.00938 29.0217 6 27.7904 6 26.3604V24.5C6 23.5681 6.63739 22.785 7.5 22.563V19.7771C7.5 17.1379 8.11447 14.535 9.29474 12.1745L10.7764 9.21115C11.454 7.85601 12.839 7 14.3541 7H49.1976C50.9269 7 52.595 7.64011 53.8803 8.79694L61.9521 16.0616L68.1705 17.098C70.0745 17.4153 71.6258 18.8003 72.1561 20.6563L73.3689 24.9011C74.099 27.4564 72.1803 30 69.5228 30H66.5V28H69.5228C70.8516 28 71.8109 26.7282 71.4459 25.4506L70.2331 21.2058C69.9149 20.0921 68.9841 19.2611 67.8417 19.0707L61.0479 17.9384L52.5424 10.2835C51.6243 9.45722 50.4328 9 49.1976 9H14.3541ZM17.9195 12C17.1394 12 16.4305 12.4536 16.1036 13.1619L14.5629 16.5H54.5V16.4142L51.2574 13.1716C50.5072 12.4214 49.4898 12 48.4289 12H17.9195ZM14.2877 12.3238C14.9415 10.9072 16.3593 10 17.9195 10H48.4289C50.0202 10 51.5464 10.6321 52.6716 11.7574L55.9142 15C56.2893 15.3751 56.5 15.8838 56.5 16.4142V16.5C56.5 17.6046 55.6046 18.5 54.5 18.5H14.5629C13.1033 18.5 12.1353 16.9871 12.747 15.6619L14.2877 12.3238ZM56 30H24.5V28H56V30Z" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fillRule="evenodd" clipRule="evenodd" d="M39 18V12H41V18H39Z" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <path fillRule="evenodd" clipRule="evenodd" d="M24 18V12H26V18H24Z" />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <path fillRule="evenodd" clipRule="evenodd" d="M42 21C42 20.4477 42.4477 20 43 20H45C45.5523 20 46 20.4477 46 21C46 21.5523 45.5523 22 45 22H43C42.4477 22 42 21.5523 42 21Z" />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <svg className="pt-1 selected-color mx-auto" width="80" height="40" viewBox="0 0 80 40" fill="black" xmlns="http://www.w3.org/2000/svg" data-v-c08e9c5a="" data-v-721a5644="">{t0}{" "}{t1}{" "}{t2}{" "}{t3}{" "}{t4}{" "}{t5}{" "}<path fillRule="evenodd" clipRule="evenodd" d="M27 21C27 20.4477 27.4477 20 28 20H30C30.5523 20 31 20.4477 31 21C31 21.5523 30.5523 22 30 22H28C27.4477 22 27 21.5523 27 21Z" /></svg>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
}
function ConvertibleSVG() {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path fillRule="evenodd" clipRule="evenodd" d="M63 30C65.2091 30 67 28.2091 67 26C67 23.7909 65.2091 22 63 22C60.7909 22 59 23.7909 59 26C59 28.2091 60.7909 30 63 30ZM63 32C66.3137 32 69 29.3137 69 26C69 22.6863 66.3137 20 63 20C59.6863 20 57 22.6863 57 26C57 29.3137 59.6863 32 63 32Z" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path fillRule="evenodd" clipRule="evenodd" d="M20 30C22.2091 30 24 28.2091 24 26C24 23.7909 22.2091 22 20 22C17.7909 22 16 23.7909 16 26C16 28.2091 17.7909 30 20 30ZM20 32C23.3137 32 26 29.3137 26 26C26 22.6863 23.3137 20 20 20C16.6863 20 14 22.6863 14 26C14 29.3137 16.6863 32 20 32Z" />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M40.6452 10.1138C38.9822 8.71338 39.9725 6 42.1466 6C42.5522 6 42.9508 6.10586 43.303 6.30711L56.8363 14.0404L71.2904 16.2989C72.5219 16.4913 73.5062 17.4252 73.7629 18.6449L74.7169 23.176C75.2403 25.6621 73.3434 28 70.8027 28H68.5V26H70.8027C72.073 26 73.0215 24.8311 72.7598 23.588L71.8058 19.0569C71.7203 18.6503 71.3922 18.339 70.9817 18.2749L56.1637 15.9596L42.3107 8.0436C42.2607 8.01503 42.2041 8 42.1466 8C41.8379 8 41.6974 8.38518 41.9334 8.58397L48.6441 14.2351C48.9655 14.5057 49.0834 14.9482 48.9394 15.3428C48.7954 15.7375 48.4201 16 48 16H10.5479C10.2198 16 9.9125 16.161 9.72571 16.4308L6.17781 21.5555C6.06203 21.7228 6 21.9213 6 22.1248V24.2654C6 24.7631 6.36593 25.185 6.85858 25.2554L15.6414 26.51L15.3586 28.49L6.57574 27.2353C5.09779 27.0241 4 25.7584 4 24.2654V22.1248C4 21.5145 4.18608 20.9188 4.53342 20.4171L8.08133 15.2924C8.64168 14.483 9.56347 14 10.5479 14H45.26L40.6452 10.1138ZM58 28H25.5V26H58V28Z" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fillRule="evenodd" clipRule="evenodd" d="M26.3634 12.0301C26.7041 9.30518 30.2232 8.4321 31.798 10.6818L32.4027 11.5457L33.4487 14.6837L31.5513 15.3161L30.5973 12.4542L30.1595 11.8287C29.6346 11.0788 28.4615 11.3699 28.348 12.2782L27.9923 15.124L26.0077 14.8759L26.3634 12.0301Z" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <svg className="pt-1 selected-color mx-auto" width="80" height="40" viewBox="0 0 80 40" fill="black" xmlns="http://www.w3.org/2000/svg" data-v-c08e9c5a="" data-v-721a5644="">{t0}{" "}{t1}{" "}{t2}{" "}{t3}{" "}<path fillRule="evenodd" clipRule="evenodd" d="M30 18C30 17.4477 30.4477 17 31 17H33C33.5523 17 34 17.4477 34 18C34 18.5523 33.5523 19 33 19H31C30.4477 19 30 18.5523 30 18Z" /></svg>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}
function CoupeSVG() {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path fillRule="evenodd" clipRule="evenodd" d="M64 30C66.2091 30 68 28.2091 68 26C68 23.7909 66.2091 22 64 22C61.7909 22 60 23.7909 60 26C60 28.2091 61.7909 30 64 30ZM64 32C67.3137 32 70 29.3137 70 26C70 22.6863 67.3137 20 64 20C60.6863 20 58 22.6863 58 26C58 29.3137 60.6863 32 64 32Z" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path fillRule="evenodd" clipRule="evenodd" d="M21 30C23.2091 30 25 28.2091 25 26C25 23.7909 23.2091 22 21 22C18.7909 22 17 23.7909 17 26C17 28.2091 18.7909 30 21 30ZM21 32C24.3137 32 27 29.3137 27 26C27 22.6863 24.3137 20 21 20C17.6863 20 15 22.6863 15 26C15 29.3137 17.6863 32 21 32Z" />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M26.4856 7.82837C27.668 7.28263 28.9548 7 30.2571 7H41.6115C43.0087 7 44.3867 7.32531 45.6364 7.95016L57.8081 14.036L72.2904 16.2989C73.5219 16.4913 74.5062 17.4252 74.7629 18.6449L75.7169 23.176C76.2403 25.6621 74.3434 28 71.8027 28H69.5V26H71.8027C73.073 26 74.0215 24.8311 73.7598 23.588L72.8058 19.0569C72.7203 18.6503 72.3922 18.339 71.9817 18.2749L57.1919 15.964L44.742 9.73901C43.77 9.25302 42.6982 9 41.6115 9H30.2571C29.2442 9 28.2434 9.21982 27.3237 9.64428L15.7781 14.973L9.01055 15.819C8.59416 15.871 8.25455 16.1775 8.16019 16.5864L7.589 19.0615C7.19778 20.7568 7 22.5115 7 24.2529C7 24.7583 7.37351 25.1861 7.85858 25.2554L16.6414 26.51L16.3586 28.49L7.57574 27.2353C6.09021 27.023 5 25.7382 5 24.2529C5 22.3617 5.2146 20.4562 5.64022 18.6118L6.21141 16.1367C6.49449 14.91 7.5133 13.9906 8.76248 13.8344L15.2219 13.027L26.4856 7.82837ZM27.5774 10.5579C28.3691 10.1904 29.2313 10 30.1041 10H41.3197C42.2511 10 43.1698 10.2169 44.0029 10.6334L52.4347 14.8493C53.0876 15.1758 53.5 15.843 53.5 16.5729C53.5 17.6372 52.6372 18.5 51.5729 18.5H24.057C20.844 18.5 19.8794 14.132 22.7937 12.779L27.5774 10.5579ZM30.1041 12C29.5223 12 28.9474 12.1269 28.4197 12.372L23.6359 14.593C22.6645 15.044 22.986 16.5 24.057 16.5H51.2639L43.1085 12.4223C42.5531 12.1446 41.9406 12 41.3197 12H30.1041ZM59 28H26.5V26H59V28Z" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fillRule="evenodd" clipRule="evenodd" d="M29 17V12H31V17H29Z" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <svg className="pt-1 selected-color mx-auto" width="80" height="40" viewBox="0 0 80 40" fill="black" xmlns="http://www.w3.org/2000/svg" data-v-c08e9c5a="" data-v-721a5644="">{t0}{" "}{t1}{" "}{t2}{" "}{t3}{" "}<path fillRule="evenodd" clipRule="evenodd" d="M31 21C31 20.4477 31.4477 20 32 20H34C34.5523 20 35 20.4477 35 21C35 21.5523 34.5523 22 34 22H32C31.4477 22 31 21.5523 31 21Z" /></svg>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}
function HatchBackSVG() {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path fillRule="evenodd" clipRule="evenodd" d="M61 30C63.2091 30 65 28.2091 65 26C65 23.7909 63.2091 22 61 22C58.7909 22 57 23.7909 57 26C57 28.2091 58.7909 30 61 30ZM61 32C64.3137 32 67 29.3137 67 26C67 22.6863 64.3137 20 61 20C57.6863 20 55 22.6863 55 26C55 29.3137 57.6863 32 61 32Z" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path fillRule="evenodd" clipRule="evenodd" d="M19 30C21.2091 30 23 28.2091 23 26C23 23.7909 21.2091 22 19 22C16.7909 22 15 23.7909 15 26C15 28.2091 16.7909 30 19 30ZM19 32C22.3137 32 25 29.3137 25 26C25 22.6863 22.3137 20 19 20C15.6863 20 13 22.6863 13 26C13 29.3137 15.6863 32 19 32Z" />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M12.1201 9.74278C11.5946 8.42905 12.5621 7 13.977 7H42.1704C43.882 7 45.5582 7.4881 47.0023 8.40705L55.8607 14.0442L70.2904 16.2989C71.5219 16.4913 72.5062 17.4252 72.7629 18.6449L73.7169 23.176C74.2403 25.6621 72.3434 28 69.8027 28H66.5V26H69.8027C71.073 26 72.0215 24.8311 71.7598 23.588L70.8058 19.0569C70.7203 18.6503 70.3922 18.339 69.9817 18.2749L55.1393 15.9558L45.9285 10.0944C44.8054 9.37963 43.5017 9 42.1704 9H13.977L14.6238 10.617L11.5774 15.1866C11.4966 15.3079 11.4433 15.4453 11.4211 15.5893L10.3579 22.5H9V24.409C9 24.8746 9.32141 25.2787 9.77514 25.3834L14.7249 26.5256L14.2751 28.4744L9.32542 27.3321C7.96423 27.018 7 25.8059 7 24.409V22.5C7 21.5194 7.70575 20.7036 8.63703 20.5329L9.44436 15.2852C9.51083 14.8532 9.67088 14.4409 9.91333 14.0772L12.3762 10.383L12.1201 9.74278ZM27.6155 12C27.2885 12 26.9627 12.0401 26.6454 12.1194L25.2399 12.4708C23.3749 12.9371 22.055 14.588 22.0017 16.5H50.4132L44.186 12.608C43.5503 12.2107 42.8157 12 42.066 12H27.6155ZM26.1603 10.1791C26.6362 10.0602 27.125 10 27.6155 10H42.066C43.1905 10 44.2924 10.316 45.246 10.912L51.5764 14.8685C52.151 15.2276 52.5 15.8574 52.5 16.5349C52.5 17.6202 51.6202 18.5 50.5349 18.5H21.8796C20.8415 18.5 20 17.6585 20 16.6204C20 13.74 21.9604 11.2291 24.7549 10.5305L26.1603 10.1791ZM56 28H24.5V26H56V28Z" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fillRule="evenodd" clipRule="evenodd" d="M36 18V11H38V18H36Z" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <path fillRule="evenodd" clipRule="evenodd" d="M39 21C39 20.4477 39.4477 20 40 20H42C42.5523 20 43 20.4477 43 21C43 21.5523 42.5523 22 42 22H40C39.4477 22 39 21.5523 39 21Z" />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <svg className="pt-1 selected-color mx-auto" data-v-c08e9c5a="" width="80" height="40" viewBox="0 0 80 40" fill="black" xmlns="http://www.w3.org/2000/svg" data-v-721a5644="">{t0}{" "}{t1}{" "}{t2}{" "}{t3}{" "}{t4}{" "}<path fillRule="evenodd" clipRule="evenodd" d="M27 21C27 20.4477 27.4477 20 28 20H30C30.5523 20 31 20.4477 31 21C31 21.5523 30.5523 22 30 22H28C27.4477 22 27 21.5523 27 21Z" /></svg>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
}
function WagonSVG() {
  const $ = _c(7);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path fillRule="evenodd" clipRule="evenodd" d="M62 30C64.2091 30 66 28.2091 66 26C66 23.7909 64.2091 22 62 22C59.7909 22 58 23.7909 58 26C58 28.2091 59.7909 30 62 30ZM62 32C65.3137 32 68 29.3137 68 26C68 22.6863 65.3137 20 62 20C58.6863 20 56 22.6863 56 26C56 29.3137 58.6863 32 62 32Z" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path fillRule="evenodd" clipRule="evenodd" d="M20 30C22.2091 30 24 28.2091 24 26C24 23.7909 22.2091 22 20 22C17.7909 22 16 23.7909 16 26C16 28.2091 17.7909 30 20 30ZM20 32C23.3137 32 26 29.3137 26 26C26 22.6863 23.3137 20 20 20C16.6863 20 14 22.6863 14 26C14 29.3137 16.6863 32 20 32Z" />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M14.1243 7H41.4831C42.9725 7 44.4386 7.36963 45.75 8.07576L56.8234 14.0384L71.2904 16.2989C72.5219 16.4913 73.5062 17.4252 73.7629 18.6449L74.7169 23.176C75.2403 25.6621 73.3434 28 70.8027 28H67.5V26H70.8027C72.073 26 73.0215 24.8311 72.7598 23.588L71.8058 19.0569C71.7203 18.6503 71.3922 18.339 70.9817 18.2749L56.1766 15.9616L44.8018 9.8367C43.7818 9.28749 42.6415 9 41.4831 9H14.8757L7.84149 15.155C7.62448 15.3448 7.5 15.6192 7.5 15.9075V22.5H6V24.2654C6 24.7631 6.36593 25.185 6.85858 25.2554L15.6414 26.51L15.3586 28.49L6.57574 27.2353C5.09779 27.0241 4 25.7584 4 24.2654V22.5C4 21.5681 4.63739 20.785 5.5 20.563V15.9075C5.5 15.0424 5.87344 14.2195 6.52449 13.6498L14.1243 7ZM16.7063 12.3417C17.842 10.8652 19.5992 10 21.462 10H41.3197C42.2511 10 43.1698 10.2169 44.0029 10.6334L52.4347 14.8493C53.0876 15.1758 53.5 15.843 53.5 16.5729C53.5 17.6372 52.6372 18.5 51.5729 18.5H16.0309C14.3715 18.5 13.4339 16.5958 14.4456 15.2806L16.7063 12.3417ZM21.462 12C20.2201 12 19.0487 12.5768 18.2915 13.5612L16.0309 16.5H51.2639L43.1085 12.4223C42.5531 12.1446 41.9406 12 41.3197 12H21.462ZM57 28H25.5V26H57V28Z" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fillRule="evenodd" clipRule="evenodd" d="M36 18V11H38V18H36Z" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <path fillRule="evenodd" clipRule="evenodd" d="M23 18V11H25V18H23Z" />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <path fillRule="evenodd" clipRule="evenodd" d="M38 21C38 20.4477 38.4477 20 39 20H41C41.5523 20 42 20.4477 42 21C42 21.5523 41.5523 22 41 22H39C38.4477 22 38 21.5523 38 21Z" />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <svg className="pt-1 selected-color mx-auto" data-v-c08e9c5a="" width="80" height="40" viewBox="0 0 80 40" fill="black" xmlns="http://www.w3.org/2000/svg" data-v-721a5644="">{t0}{" "}{t1}{" "}{t2}{" "}{t3}{" "}{t4}{" "}{t5}{" "}<path fillRule="evenodd" clipRule="evenodd" d="M26 21C26 20.4477 26.4477 20 27 20H29C29.5523 20 30 20.4477 30 21C30 21.5523 29.5523 22 29 22H27C26.4477 22 26 21.5523 26 21Z" /></svg>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
}
function ElectricSVG() {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path fillRule="evenodd" clipRule="evenodd" d="M62 30C64.2091 30 66 28.2091 66 26C66 23.7909 64.2091 22 62 22C59.7909 22 58 23.7909 58 26C58 28.2091 59.7909 30 62 30ZM62 32C65.3137 32 68 29.3137 68 26C68 22.6863 65.3137 20 62 20C58.6863 20 56 22.6863 56 26C56 29.3137 58.6863 32 62 32Z" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path fillRule="evenodd" clipRule="evenodd" d="M20 30C22.2091 30 24 28.2091 24 26C24 23.7909 22.2091 22 20 22C17.7909 22 16 23.7909 16 26C16 28.2091 17.7909 30 20 30ZM20 32C23.3137 32 26 29.3137 26 26C26 22.6863 23.3137 20 20 20C16.6863 20 14 22.6863 14 26C14 29.3137 16.6863 32 20 32Z" />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M30 13.5C30 12.9477 30.4477 12.5 31 12.5H44.5C45.0523 12.5 45.5 12.9477 45.5 13.5V15H46.5C47.0523 15 47.5 15.4477 47.5 16V20C47.5 20.5523 47.0523 21 46.5 21H45.5V22.5C45.5 23.0523 45.0523 23.5 44.5 23.5H31C30.4477 23.5 30 23.0523 30 22.5V13.5ZM45.5 19V17H44.5C43.9477 17 43.5 16.5523 43.5 16V14.5H32V21.5H43.5V20C43.5 19.4477 43.9477 19 44.5 19H45.5Z" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fillRule="evenodd" clipRule="evenodd" d="M35 12.5C35.5523 12.5 36 12.9477 36 13.5V22.5C36 23.0523 35.5523 23.5 35 23.5C34.4477 23.5 34 23.0523 34 22.5V13.5C34 12.9477 34.4477 12.5 35 12.5Z" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <path fillRule="evenodd" clipRule="evenodd" d="M39 12.5C39.5523 12.5 40 12.9477 40 13.5V22.5C40 23.0523 39.5523 23.5 39 23.5C38.4477 23.5 38 23.0523 38 22.5V13.5C38 12.9477 38.4477 12.5 39 12.5Z" />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <svg className="pt-1 selected-color mx-auto" data-v-c08e9c5a="" width="80" height="40" viewBox="0 0 80 40" fill="black" xmlns="http://www.w3.org/2000/svg" data-v-721a5644="">{t0}{" "}{t1}{" "}{t2}{" "}{t3}{" "}{t4}{" "}<path fillRule="evenodd" clipRule="evenodd" d="M25.4856 7.82837C26.668 7.28263 27.9548 7 29.2571 7H41.4831C42.9725 7 44.4386 7.36963 45.75 8.07576L56.8234 14.0384L71.2904 16.2989C72.5219 16.4913 73.5062 17.4252 73.7629 18.6449L74.7169 23.176C75.2403 25.6621 73.3434 28 70.8027 28H67.5V26H70.8027C72.073 26 73.0215 24.8311 72.7598 23.588L71.8058 19.0569C71.7203 18.6503 71.3922 18.339 70.9817 18.2749L56.1766 15.9616L44.8018 9.8367C43.7818 9.28749 42.6415 9 41.4831 9H29.2571C28.2442 9 27.2434 9.21982 26.3237 9.64428L14.7781 14.973L8.37597 15.7733C7.87554 15.8358 7.5 16.2612 7.5 16.7656V22.5H6V24.2654C6 24.7631 6.36593 25.185 6.85858 25.2554L15.6414 26.51L15.3586 28.49L6.57574 27.2353C5.09779 27.0241 4 25.7584 4 24.2654V22.5C4 21.5681 4.63739 20.785 5.5 20.563V16.7656C5.5 15.2526 6.62661 13.9764 8.1279 13.7887L14.2219 13.027L25.4856 7.82837ZM57 28H25.5V26H57V28Z" /></svg>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
}
function ColorWheelSVG() {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <style type="text/css">{"\n\t.st0{fill:#E0E0D1;}\n\t.st1{opacity:0.2;}\n\t.st2{fill:#231F20;}\n\t.st3{fill:#77B3D4;}\n\t.st4{fill:#76C2AF;}\n\t.st5{fill:#E0995E;}\n\t.st6{fill:#C75C5C;}\n\t.st7{fill:#F5CF87;}\n\t.st8{fill:#4F5D73;}\n"}</style>;
    t1 = <circle className="st0" cx={32} cy={32} r={32} />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <svg height="24px" width="24px" className="other-icon" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 64 64" xmlSpace="preserve">{t0}{t1}<g className="st1"><path className="st2" d="M19.5,37.5c-0.2-0.9-1-1.5-1.9-1.5h-5.2c-0.6,0-1.2,0.3-1.5,0.7c-0.4,0.5-0.5,1.1-0.4,1.7 c0.9,4.5,3.2,8.5,6.5,11.6c0.4,0.4,0.9,0.5,1.4,0.5c0.1,0,0.2,0,0.3,0c0.6-0.1,1.1-0.4,1.4-1l2.6-4.5c0.4-0.8,0.3-1.7-0.2-2.3 C21,41.2,20,39.4,19.5,37.5z" /><path className="st2" d="M36.9,47.7c-0.4-0.6-1-1-1.7-1c-0.1,0-0.3,0-0.4,0C33.8,46.9,32.9,47,32,47c-1.3,0-2.5-0.2-3.8-0.6 c-0.2-0.1-0.4-0.1-0.6-0.1c-0.7,0-1.4,0.4-1.7,1l-2.6,4.4c-0.3,0.5-0.3,1.1-0.1,1.7c0.2,0.6,0.6,1,1.2,1.2c2.4,0.9,5,1.3,7.6,1.3 c2.2,0,4.3-0.3,6.3-0.9c0.6-0.2,1.1-0.6,1.3-1.2c0.2-0.6,0.2-1.2-0.1-1.7L36.9,47.7z" /><path className="st2" d="M44.5,30.5c0.2,0.9,1,1.5,1.9,1.5h5.2c0.6,0,1.2-0.3,1.5-0.7c0.4-0.5,0.5-1.1,0.4-1.7c-1-4.9-3.6-9.3-7.5-12.5 c-0.4-0.3-0.8-0.5-1.3-0.5c-0.1,0-0.2,0-0.4,0c-0.6,0.1-1.1,0.5-1.4,1l-2.6,4.4c-0.5,0.8-0.3,1.8,0.4,2.5 C42.6,26.2,43.9,28.2,44.5,30.5z" /><path className="st2" d="M38.3,12.9c-2-0.6-4.2-0.9-6.3-0.9c-2.6,0-5.2,0.5-7.6,1.3c-0.6,0.2-1,0.6-1.2,1.2c-0.2,0.6-0.1,1.2,0.1,1.7 l2.6,4.4c0.4,0.6,1,1,1.7,1c0.2,0,0.4,0,0.6-0.1c1.2-0.4,2.5-0.6,3.8-0.6c0.9,0,1.8,0.1,2.7,0.3c0.1,0,0.3,0,0.4,0 c0.7,0,1.4-0.4,1.7-1l2.6-4.5c0.3-0.5,0.4-1.2,0.1-1.7C39.4,13.5,38.9,13.1,38.3,12.9z" /><path className="st2" d="M51.6,36h-5.2c-0.9,0-1.7,0.6-1.9,1.5c-0.6,2.3-1.9,4.4-3.6,6c-0.7,0.6-0.8,1.7-0.4,2.5l2.6,4.4 c0.3,0.5,0.8,0.9,1.4,1c0.1,0,0.2,0,0.4,0c0.5,0,0.9-0.2,1.3-0.5c3.8-3.2,6.5-7.6,7.5-12.5c0.1-0.6,0-1.2-0.4-1.7 C52.8,36.3,52.2,36,51.6,36z" /><path className="st2" d="M20,18.4c-0.3-0.5-0.8-0.9-1.4-1c-0.1,0-0.2,0-0.3,0c-0.5,0-1,0.2-1.4,0.5c-3.3,3.1-5.6,7.2-6.5,11.6 c-0.1,0.6,0,1.2,0.4,1.7c0.4,0.5,0.9,0.7,1.5,0.7h5.2c0.9,0,1.7-0.6,1.9-1.5c0.5-1.9,1.5-3.8,2.9-5.3c0.6-0.6,0.7-1.6,0.2-2.3 L20,18.4z" /></g><g><path className="st3" d="M19.5,35.5c-0.2-0.9-1-1.5-1.9-1.5h-5.2c-0.6,0-1.2,0.3-1.5,0.7c-0.4,0.5-0.5,1.1-0.4,1.7 c0.9,4.5,3.2,8.5,6.5,11.6c0.4,0.4,0.9,0.5,1.4,0.5c0.1,0,0.2,0,0.3,0c0.6-0.1,1.1-0.4,1.4-1l2.6-4.5c0.4-0.8,0.3-1.7-0.2-2.3 C21,39.2,20,37.4,19.5,35.5z" /><path className="st4" d="M36.9,45.7c-0.4-0.6-1-1-1.7-1c-0.1,0-0.3,0-0.4,0C33.8,44.9,32.9,45,32,45c-1.3,0-2.5-0.2-3.8-0.6 c-0.2-0.1-0.4-0.1-0.6-0.1c-0.7,0-1.4,0.4-1.7,1l-2.6,4.4c-0.3,0.5-0.3,1.1-0.1,1.7c0.2,0.6,0.6,1,1.2,1.2c2.4,0.9,5,1.3,7.6,1.3 c2.2,0,4.3-0.3,6.3-0.9c0.6-0.2,1.1-0.6,1.3-1.2c0.2-0.6,0.2-1.2-0.1-1.7L36.9,45.7z" /><path className="st5" d="M44.5,28.5c0.2,0.9,1,1.5,1.9,1.5h5.2c0.6,0,1.2-0.3,1.5-0.7c0.4-0.5,0.5-1.1,0.4-1.7c-1-4.9-3.6-9.3-7.5-12.5 c-0.4-0.3-0.8-0.5-1.3-0.5c-0.1,0-0.2,0-0.4,0c-0.6,0.1-1.1,0.5-1.4,1l-2.6,4.4c-0.5,0.8-0.3,1.8,0.4,2.5 C42.6,24.2,43.9,26.2,44.5,28.5z" /><path className="st6" d="M38.3,10.9c-2-0.6-4.2-0.9-6.3-0.9c-2.6,0-5.2,0.5-7.6,1.3c-0.6,0.2-1,0.6-1.2,1.2c-0.2,0.6-0.1,1.2,0.1,1.7 l2.6,4.4c0.4,0.6,1,1,1.7,1c0.2,0,0.4,0,0.6-0.1c1.2-0.4,2.5-0.6,3.8-0.6c0.9,0,1.8,0.1,2.7,0.3c0.1,0,0.3,0,0.4,0 c0.7,0,1.4-0.4,1.7-1l2.6-4.5c0.3-0.5,0.4-1.2,0.1-1.7C39.4,11.5,38.9,11.1,38.3,10.9z" /><path className="st7" d="M51.6,34h-5.2c-0.9,0-1.7,0.6-1.9,1.5c-0.6,2.3-1.9,4.4-3.6,6c-0.7,0.6-0.8,1.7-0.4,2.5l2.6,4.4 c0.3,0.5,0.8,0.9,1.4,1c0.1,0,0.2,0,0.4,0c0.5,0,0.9-0.2,1.3-0.5c3.8-3.2,6.5-7.6,7.5-12.5c0.1-0.6,0-1.2-0.4-1.7 C52.8,34.3,52.2,34,51.6,34z" /><path className="st8" d="M20,16.4c-0.3-0.5-0.8-0.9-1.4-1c-0.1,0-0.2,0-0.3,0c-0.5,0-1,0.2-1.4,0.5c-3.3,3.1-5.6,7.2-6.5,11.6 c-0.1,0.6,0,1.2,0.4,1.7c0.4,0.5,0.9,0.7,1.5,0.7h5.2c0.9,0,1.7-0.6,1.9-1.5c0.5-1.9,1.5-3.8,2.9-5.3c0.6-0.6,0.7-1.6,0.2-2.3 L20,16.4z" /></g></svg>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
function ManualSVG() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M12 3C12.5523 3 13 3.44772 13 4V8.12602C12.6804 8.04375 12.3453 8 12 8C11.6547 8 11.3196 8.04375 11 8.12602V4C11 3.44772 11.4477 3 12 3ZM8.12602 11H5V4C5 3.44772 4.55228 3 4 3C3.44772 3 3 3.44772 3 4V12V20C3 20.5523 3.44772 21 4 21C4.55228 21 5 20.5523 5 20V13H8.12602C8.04375 12.6804 8 12.3453 8 12C8 11.6547 8.04375 11.3196 8.12602 11ZM11 15.874V20C11 20.5523 11.4477 21 12 21C12.5523 21 13 20.5523 13 20V15.874C12.6804 15.9562 12.3453 16 12 16C11.6547 16 11.3196 15.9562 11 15.874ZM15.874 13H20C20.5523 13 21 12.5523 21 12V4C21 3.44772 20.5523 3 20 3C19.4477 3 19 3.44772 19 4V11H15.874C15.9562 11.3196 16 11.6547 16 12C16 12.3453 15.9562 12.6804 15.874 13Z" fill="#1A1919" /><circle cx="12" cy="12" r="3" stroke="#1A1919" strokeWidth="2" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function AutomaticSVG() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M8 2C7.44772 2 7 2.44772 7 3V5.12602C7.31962 5.04375 7.6547 5 8 5C8.3453 5 8.68038 5.04375 9 5.12602V4H18C18.5523 4 19 3.55228 19 3C19 2.44772 18.5523 2 18 2H8ZM11.874 8C11.9562 8.31962 12 8.6547 12 9C12 9.3453 11.9562 9.68038 11.874 10H18C18.5523 10 19 9.55228 19 9C19 8.44772 18.5523 8 18 8H11.874ZM9 12.874C8.68038 12.9562 8.3453 13 8 13C7.6547 13 7.31962 12.9562 7 12.874V15V21C7 21.5523 7.44772 22 8 22H18C18.5523 22 19 21.5523 19 21C19 20.4477 18.5523 20 18 20H9V16H18C18.5523 16 19 15.5523 19 15C19 14.4477 18.5523 14 18 14H9V12.874Z" fill="black" /><circle cx="8" cy="9" r="3" stroke="black" strokeWidth="2" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export { SedanSVG, SUVSVG, TruckSVG, VanSVG, ConvertibleSVG, CoupeSVG, HatchBackSVG, WagonSVG, ElectricSVG, ColorWheelSVG, ManualSVG, AutomaticSVG };